import request from '@/utils/request'
/**
 * code换取学校信息
 * @method project
 */
export function project(data) {
    return request({
        url: '/api/excellent.query.project',
        method: 'post',
        data
    })
}
/**
 * 登录接口
 * @method executeLogin
 */
export function executeLogin(data) {
    return request({
        url: '/api/member.execute.login',
        method: 'post',
        data
    })
}
/**
 * 获取验证码
 * @method verifycode
 */
export function verifycode(data) {
    return request({
        url: '/api/verify.code.verifycode',
        method: 'post',
        data
    })
}
/**
 * 验证 验证码
 * @method verification
 */
export function verification(data) {
    return request({
        url: '/api/verify.code.verification',
        method: 'post',
        data
    })
}
/**
 * 提交 密码
 * @method forgetpassword
 */
export function forgetpassword(data) {
    return request({
        url: '/api/member.execute.forgetpassword',
        method: 'post',
        data
    })
}
/**
 * 提交 密码
 * @method submit
 */
export function submit(data) {
    return request({
        url: '/api/excellent.form.submit',
        method: 'post',
        data
    })
}
/**
 * 获取动态form
 * @method creator
 */
export function creator(data) {
    return request({
        url: '/api/excellent.form.creator',
        method: 'post',
        data
    })
}
/**
 * 获取个人信息
 * @method creator
 */
export function information(data) {
    return request({
        url: '/api/member.query.information',
        method: 'post',
        data
    })
}
/**
 * 获取按钮
 * @method getbtnmation
 */
export function getbtnmation(data) {
    return request({
        url: '/api/member.enroll.getbtn',
        method: 'post',
        data
    })
}
/**
 * 查看分数按钮
 * @method getfraction
 */
export function getfraction(data) {
    return request({
        url: '/api/member.enroll.getfraction',
        method: 'post',
        data
    })
}
/**
 * 获取准考证信息
 * @method getticket
 */
export function getticket(data) {
    return request({
        url: '/api/member.enroll.getticket',
        method: 'post',
        data
    })
}
/**
 * 修改表单
 * @method edit
 */
export function edit(data) {
    return request({
        url: '/api/excellent.form.edit',
        method: 'post',
        data
    })
}

// this.time = new Date().getTime();
export function verifyimage(data) {
    return request({
        url: '/api/verify.code.image' + "?id=" + new Date().getTime(),
        method: 'get',
        data
    })
}